import React from "react";
import { IDocumentViewProps } from "../type/document.types";
import { Space } from "antd";
import { DeleteOutlined, FileOutlined } from "@ant-design/icons";


const DocumentView:React.FC<IDocumentViewProps>= (props)=> {
    return (
        <div
            className={'pn-document__view'}
            onClick={props.openPreview}
        >
            <Space>
                <FileOutlined style={{color: '#1677ff'}}/>
                <span className={'pn-document__file-name'}>{props.docName}</span>
            </Space>
            <DeleteOutlined
                className={'pn-document__delete'}
                onClick={(event: any) => props.deleteDocument(event)}
            />
        </div>
    )
}
export default DocumentView;
